<div class="grid">
  @if (rentalData) {
    <p-card header="Rental Item" class="w-full m-3">
      <div class="text-2xl font-bold text-900">{{ rentalData.subCategory.webTitle}}</div>
      <div class="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
        <img class="w-full"
             [src]="rentalData.subCategory.thumbSrc | hasImage"
             [alt]="rentalData.subCategory.webTitle"/>
        <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
          <div class="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
            <span class="text-2xl font-semibold">
              
            </span>
          </div>
        </div>
      </div>
    </p-card>
  }
  @if (strData$ | async; as strData) {
    <p-card header="Time Slot" class="w-full m-3">
      <div class="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
        <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
          <div class="font-bold text-900">{{ strData.pickupDateString | date }} &mdash; {{strData.returnDateString | date}}</div>
          <div class="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
            <span class="font-semibold">
              {{strData.strAmount?.total | currency}}
            </span>
          </div>
        </div>
      </div>
    </p-card>
  }
</div>
<!-- <div class="text-right text-2xl font-semibold pr-3">Items & Down Payment: {{totals.items | currency}}</div> -->
<!-- <div class="text-right text-2xl font-semibold pr-3">Shipping: {{totals.shipping | currency}}</div> -->
<div class="text-right text-2xl font-semibold pr-3">{{taxName()}}: {{totals.tax | currency}}</div>
@if (tax2Name()) {
  <div class="text-right text-2xl font-semibold pr-3">{{tax2Name()}}: {{totals.tax2 | currency}}</div>
}
<p-divider></p-divider>
<div class="text-right text-3xl font-semibold pr-3 mb-2">Total: {{totals.total | currency}}</div>
<div class="text-right text-3xl font-semibold pr-3">
  @if (userMustClickIAgree) {
    <div class="text-sm font-normal mb-2">
      <p-checkbox 
        [(ngModel)]="iAgree"
        class="i-agree"
        binary="true"
        inputId="agree"/>
      <label for="agree">
        By clicking CHECKOUT, you acknowledge and agree to the <span class="terms" (click)="onTermsClick($event)">terms and conditions</span>
      </label>
    </div>
  }
  <p-button (onClick)="onCompleteClick()" [loading]="isProcessing" [disabled]="isProcessing || (userMustClickIAgree && !iAgree)" label="CHECKOUT"></p-button>
</div>
<p-dialog header="Error" [(visible)]="showError">
  <p>
    Your payment was declined.
  </p>
</p-dialog>
